import APIClient from '../../../common/APIClient';
import { displayError, ERROR_ALERT, setIsSaving, SUCCESS_ALERT, toggleShowAlert } from '../commonActions';
import { getProject, resetProject, SET_PROJECT, upsertProject } from './projectsActions';
import qs from 'qs';

const FETCH_PROJECT_MEMBERS = 'FETCH_PROJECT_MEMBERS';
const FETCH_MEMBER_PROJECTS = 'FETCH_MEMBER_PROJECTS';
const RESET_PROJECT_MEMBERS = 'RESET_PROJECT_MEMBERS';
const ADD_PROJECT_MEMBER = 'ADD_PROJECT_MEMBER';

const client = () => {
  var apiClient = new APIClient();
  return apiClient.make();
}

export const fetchProjectMembers = (projectId, notProjMemberPage = false) => {
  return (dispatch, getState) => {
    let project = getState().projects.project;
    if (!projectId) {
      projectId = project.id;
    }

    if (!projectId) {
      return null;
    }
    
    client().get(
      'team-members/list', {
        params: {
          project_id: projectId 
        }, 
        paramsSerializer: params => {
          return qs.stringify(params)
        }
      }
    ).then(json => {
      const result = json.data;
      if (result) {
        let projectMembers = result.data;

        
        if (projectMembers.length === 0) {
          projectMembers = null;
          //if not in project member page, don't update budgeted hours
          if (!notProjMemberPage) {
            let project = getState().projects.project;
            project.budgeted_hours = project.costing_budgeted_hours;
            dispatch({type: SET_PROJECT, project});
            dispatch(upsertProject('UPDATE_PROJECT', null, false, false, false));
          }
        }        

        dispatch({type: FETCH_PROJECT_MEMBERS, projectMembers});
        dispatch(computePartialManhours(projectMembers));
      }
    }).catch(error => {
      dispatch(displayError(error));
    })
  }
}

export const fetchMemberProjects = (userId, filters = {}) => {
  return (dispatch) => {
    let params = {
      user_id: userId
    } 

    if (filters && Object.keys(filters).length) {
      Object.assign(params, {filters});
    }

    client().get(
      'team-members/member/projects', {
        params, 
        paramsSerializer: params => {
          return qs.stringify(params)
        }
      }
    ).then(json => {
      const result = json.data;
      if (result) {
        let data = result.data;
        if (data) {
          if (data.length === 0) {
            data = null;
          }
          dispatch({type: FETCH_MEMBER_PROJECTS, memberProjects: data});
        }
      }
    }).catch(error => {
      dispatch(displayError(error));
    })
  }
}

export const addProjectMembers = () => {
  return (dispatch, getState) => {
    const project = getState().projects.project;
    if (Object.keys(project).length > 0) {
      if (typeof(project.team_members) !== "undefined") {
        let teamMembers = project.team_members;
        let membersDetails = [];
        
        teamMembers.length && teamMembers.forEach(teamMember => {
          membersDetails.push({
            user_id: teamMember, 
            hours: null, 
            platform_id: null, 
            member_band_cost: null 
          })
        })

        client().post(
          'team-members/create', {
            project_id: project.id, 
            member_details: membersDetails 
          }
        ).then(json => {
          const result = json.data;
          if (result) {
            dispatch(resetProject());
            dispatch(getProject(project.id));
          }
        }).catch(error => {
          dispatch(displayError(error));
        })
      }
    }
  }
}

export const addProjectMember = (projectMember) => {
  return (dispatch, getState) => {
    const project = getState().projects.project;
    const projectMembers = getState().projects.projectMembers;
    let arrMembers = [];
    if (Object.keys(projectMember).length) {

      arrMembers.push({
        user_id: projectMember.id, 
        hours: null, 
        platform_id: null, 
        member_band_cost: null 
      })

      client().post(
        'team-members/create', {
          project_id: project.id, 
          member_details: arrMembers 
        }
      ).then(json => {
        const result = json.data;
        if (result) {
          dispatch(toggleShowAlert(true, SUCCESS_ALERT, "User has been successfully added as member."));

          if (projectMembers) {
            dispatch({type: ADD_PROJECT_MEMBER, projectMember: {
              id: result.data, 
              member_band_cost: null, 
              project_budgeted_hours: projectMember.budgeted_hours, 
              project_id: project.id, 
              user: projectMember, 
              user_budgeted_hours: null
            }})
          }
          else {
            dispatch(fetchProjectMembers());
          }
        }
      }).catch(error => {
        dispatch(displayError(error));
      })
    }
  }
}

export const resetProjectMembers = () => {
  return (dispatch) => {
    dispatch({type: RESET_PROJECT_MEMBERS})
  }
}

export const deleteProjectMember = (id) => {
  return (dispatch, getState) => {
    const project = getState().projects.project;
    let projectMembers = getState().projects.projectMembers;

    if (Object.keys(project).length > 0) {
      client().get(
        'team-members/delete', {
          params: {
            id
          }
        }
      ).then(json => {
        const result = json.data;
        if (result) {
          dispatch(toggleShowAlert(true, SUCCESS_ALERT, "Member has been removed from the project."));
          if (projectMembers && projectMembers.length) {
            projectMembers = projectMembers.filter(data => {
              if (data.id !== id) {
                return true;
              }
              return false;
            }).map(projectMember => {
              return projectMember;
            })

            dispatch({type: FETCH_PROJECT_MEMBERS, projectMembers});
          }
        }
      }).catch(error => {
        dispatch(displayError(error));
      })
    }
  }
}

export const updateMembers = () => {
  return (dispatch, getState) => {
    let project = getState().projects.project;
    let projectMembers = getState().projects.projectMembers;

    if (project.partial_cost > project.fully_loaded_cost) {
      dispatch(toggleShowAlert(true, ERROR_ALERT, " Total Budget Cost should be less than or equal to Fully Loaded Cost."));
      return true;
    }

    if (projectMembers) {
      projectMembers = projectMembers.length && projectMembers.map(projectMember => {
        return {
          user_id: projectMember.user.id, 
          project_id: projectMember.project_id, 
          hours: projectMember.user_budgeted_hours,
          member_band_cost: projectMember.member_band_cost,
          platform_id: projectMember.user.group.id,
        }
      })

      if (Object.keys(project).length > 0) {
        dispatch(setIsSaving(true));
  
        return client().post(
          'team-members/update', {
            members: projectMembers
          }
        ).then(json => {
          const result = json.data;
          if (result) {
            //upon saving let's overwrite the budgeted hours 
            if (project.budgeted_hours !==  project.partial_budgeted_hours) {
              project.budgeted_hours = project.partial_budgeted_hours;
              dispatch({type: SET_PROJECT, project});
              dispatch(upsertProject('UPDATE_PROJECT', () => {
                dispatch(resetProject());
                dispatch(getProject(project.id));
                dispatch(toggleShowAlert(true, SUCCESS_ALERT, "Team members has been successfully updated."));
                dispatch(setIsSaving(false));
              }, false, false, false));
            }
            
          }
          return true;
        }).catch(error => {
          dispatch(displayError(error));
          dispatch(setIsSaving(false));
          return false;
        })
      }
    }
    else {
      dispatch(toggleShowAlert(true, ERROR_ALERT, "Please add members."));
    }
  }
}

export const updateMemberHours = (memberHours, memberId) => {
  return (dispatch, getState) => {
    let projectMembers = getState().projects.projectMembers;
    
    projectMembers = projectMembers && projectMembers.length && projectMembers.map(member => {
      if (member.id === memberId) {
        member.user_budgeted_hours = memberHours;
        if (typeof(member.user) !== "undefined" && member.user) {
          const memberUser = member.user;
          if (typeof(memberUser.band_cost) !== "undefined" && memberUser.band_cost) {
            const memberBandCosts = memberUser.band_cost;
            const project = member.project_details;
            let bandCost = {}
            if (typeof(project) !== "undefined") {
              memberBandCosts.filter(data => {
                if (data.year === project.costing_year && data.fully_loaded === project.fully_loaded) {
                  return data;
                }
                return null;
              }).forEach(memberBandCost => {
                bandCost = memberBandCost;
              })
            }
            if (Object.keys(bandCost).length) {
              member.member_band_cost = bandCost.cost * memberHours;
            } 
            else {
              alert('User has no group.');
            }                      
          }
        }
      }

      return member;
    })

    dispatch({type: FETCH_PROJECT_MEMBERS, projectMembers});
    dispatch(computePartialManhours(projectMembers));
  }
}

export const computeMemberBandCost = (bandCost, memberId) => {
  return (dispatch, getState) => {
    let projectMembers = getState().projects.projectMembers;
  
    projectMembers = projectMembers && projectMembers.length && projectMembers.map(member => {
      if (member.id === memberId) {
        let memberBandCost = bandCost;
        if (member.user_budgeted_hours) {
          memberBandCost = bandCost * member.user_budgeted_hours;
        }
        member.group_band_cost = bandCost;
        member.member_band_cost = memberBandCost;
      }

      return member;
    })

    dispatch({type: FETCH_PROJECT_MEMBERS, projectMembers});
    dispatch(computePartialManhours(projectMembers));
  }
}

export const computePartialManhours = (projectMembers) => {
  return (dispatch, getState) => {
    let project = getState().projects.project;
    let totalManhours = 0;
    let totalCost = 0;
    projectMembers.length && projectMembers.forEach(member => {
      totalManhours += member.user_budgeted_hours;
      totalCost += member.member_band_cost;
    })

    project.partial_budgeted_hours = parseFloat(parseFloat(totalManhours).toFixed(2));
    project.partial_cost = parseFloat(parseFloat(totalCost).toFixed(2));

    if (project.partial_cost > project.fully_loaded_cost) {
      dispatch(toggleShowAlert(true, ERROR_ALERT, "Team Members exceeded the Project Budget Cost"));
    }
    else {
      dispatch({type: SET_PROJECT, project});
    }
  }
}
